import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import BoardsTabsComponent from 'webapp/components/boards-tabs';

export default class BoardsTabsRouteTemplate extends Component {
	@service('model-manager/boards') declare mmBoardsService: Service.ModelManager.Boards;

	get boards() {
		return this.mmBoardsService.normalBoardModels;
	}

	<template><BoardsTabsComponent @model={{this.boards}} /></template>
}
